// @flow

import { useEffect, useState } from 'react';
import { useIncomingPayment } from '@tectonics/prs/incoming-payment';

/** @deprecated */
export const useCountdown = (targetDate :number) => {
  const incomingPayment = useIncomingPayment();
  const hash = incomingPayment ? incomingPayment.hash : null;
  const storageKey = hash ? `countDown_${hash}` : 'countDown';
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(() => {
    const remainingUntilTarget = countDownDate - Date.now();
    const storedCountDown = localStorage.getItem(storageKey);
    if (storedCountDown) {
      return Math.min(parseInt(storedCountDown, 10), remainingUntilTarget);
    }
    return remainingUntilTarget;
  });

  useEffect(() => {
    let interval;
    if (countDown >= 0) {
      interval = setInterval(() => {
        setCountDown(prevCountDown => prevCountDown - 1000);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [countDown]);

  useEffect(() => {
    localStorage.setItem(storageKey, countDown.toString());
  }, [countDown, storageKey]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};

export function zeroPad(value: number | string, length: number = 2): string {
  const strValue = String(value);
  if (length === 0) return strValue;
  const match = strValue.match(/(.*?)([0-9]+)(.*)/);
  const prefix = match ? match[1] : '';
  const suffix = match ? match[3] : '';
  const strNo = match ? match[2] : strValue;
  const paddedNo =
    strNo.length >= length
      ? strNo
      : ([...Array(length)].map(() => '0').join('') + strNo).slice(length * -1);
  return `${prefix}${paddedNo}${suffix}`;
}
